module.exports = __webpack_public_path__ + "img/17.3f852cbc.png";